const axios = require('axios');
const { notify } = require('../utils/notification');

async function getContacts(apiKey) {
  try {
    //return [];
    var config = {
      method: 'get',
      url: 'https://delicate-mud-81d7.nanosolutions.workers.dev/?https://app.jobnimbus.com/api1/contacts/?size=5',
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
        Authorization: `bearer ${apiKey}`
      }
    };

    const response = await axios(config)
      .then(function (response) {
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
        throw error;
      });

    return response;
  } catch (error) {
    return notify('danger', 'Error', `Could not load contacts: ${error.message}`);
  }
}

async function createFile(apiKey, blob, fileName, jnid) {
  try {
    var base64result = blob.split(',')[1];

    //var base64result = blob;
    var raw = JSON.stringify({
      data: base64result,
      is_private: false,
      related: [jnid],
      type: 7,
      subtype: 'contact',
      filename: fileName,
      description: 'Fence sketch',
      date: Date.now(),
      persist: true
    });

    var config = {
      method: 'post',
      url: 'https://delicate-mud-81d7.nanosolutions.workers.dev/?https://app.jobnimbus.com/api1/files',
      headers: {
        Accept: '*/*',
        'Content-Type': 'application/json',
        Authorization: `bearer ${apiKey}`
      },
      data: raw
    };

    const response = await axios(config)
      .then(function (response) {
        notify('success', 'Success', 'File successfully uploaded to JobNimbus');
        return response.data;
      })
      .catch(function (error) {
        console.log(error);
      });

    return response;
  } catch (error) {
    return notify('danger', 'Error', `Failed to upload: ${error.message}`);
  }
}

async function login(email, password) {
  return await fetch('https://delicate-mud-81d7.nanosolutions.workers.dev/?https://app.jobnimbus.com/api1/auth', {
    headers: {
      accept: 'application/json, text/javascript, */*; q=0.01',
      'accept-language': 'en-US,en;q=0.9',
      'content-type': 'application/json; charset=UTF-8'
    },
    referrer: 'https://webappui.jobnimbus.com/',
    referrerPolicy: 'strict-origin-when-cross-origin',
    body: JSON.stringify({ user: email, pass: password }),
    method: 'POST',
    mode: 'cors',
    credentials: 'include'
  })
    .then((data) => data.json())
    .catch((err) => console.log(err.message));
}

async function getAccessToken(refresh_token) {
  const response = await fetch('https://delicate-mud-81d7.nanosolutions.workers.dev/?https://app.jobnimbus.com/api1/auth/refresh', {
    headers: {
      accept: 'application/json, text/javascript, */*; q=0.01',
      'accept-language': 'en-US,en;q=0.9',
      'content-type': 'application/json; charset=UTF-8',
      Authorization: `Bearer ${refresh_token}`
    },
    referrer: 'https://webappui.jobnimbus.com/',
    referrerPolicy: 'strict-origin-when-cross-origin',

    method: 'POST',
    mode: 'cors',
    credentials: 'include'
  })
    .then((data) => data.json())
    .catch((err) => console.log(err.message));

  return response.data.accessToken;
}

async function loginAndGetAccessToken(email, password) {
  const loginResponse = await login(email, password);
  console.log(loginResponse);
  console.log(loginResponse.headers);
  // const refreshToken = loginResponse.headers
  //   .raw()
  //   ['set-cookie'].toString()
  //   .match(/(?<=refreshToken=).*?([^;]+)/g)[0];
  const refreshToken = loginResponse.data.refreshToken;
  const accessToken = await getAccessToken(refreshToken);

  return accessToken;
}

async function createEstimate(items, accessToken) {
  const headers = {
    accept: 'application/json, text/javascript, */*; q=0.01',
    'accept-language': 'en-US,en;q=0.9',
    authorization: 'Bearer ' + accessToken,
    'content-type': 'application/json',
    'sec-ch-ua': '"Not_A Brand";v="8", "Chromium";v="120", "Google Chrome";v="120"'
  };

  const response = await fetch('https://delicate-mud-81d7.nanosolutions.workers.dev/?https://app.jobnimbus.com/api2/updateestimate', {
    headers: { ...headers },
    referrer: 'https://webappui.jobnimbus.com/',
    referrerPolicy: 'strict-origin-when-cross-origin',
    body: '{"merged":null,"class_id":"","source":null,"guid":null,"class_name":"","recid":0,"supplier":{"type":"","po":null,"branch":null,"customer_branch":null,"customer_job":null,"customer_job_name":null,"status":null,"delivery_time":null,"shipping_method":null,"order_type":null,"logs":[]},"suppliers":[],"attachment_id":null,"customer":null,"type":"estimate","created_by":null,"created_by_name":null,"date_sign_requested":0,"date_signed":0,"date_created":0,"date_updated":0,"is_active":true,"signature_status":null,"related":[{"id":"lagyj1grrxgpfq07lxu2eih","name":"test test","number":"1137","type":"contact","email":null,"subject":null,"is_primary":false,"total":0,"costs":null,"items_wo":null,"customer_note":null,"internal_note":null,"items_mo":null,"open_edge_id":null}],"owners":[],"sales_rep":null,"sales_rep_name":null,"status":0,"status_name":null,"number":null,"cost":170,"margin":0,"subtotal":340,"tax":0,"total":340,"location":{"id":0},"note":null,"internal_note":null,"date_estimate":1706076000,"date_status_change":0,"items":[{"is_visible":true,"jnid":"lek6ac0hi1cbd3bl4y95tk5","showGroupTotal":true,"id":0,"name":"4’ walk gate steel","description":"4\' wide walk gate\\nhinge posts set 3\' deep\\nblack powder coated 2 hinge latch set","quantity":1,"tax_couch_id":null,"price":340,"cost":170,"margin":100,"addMarkup":null,"addMarkupIsExcluded":false,"totalMarkup":0,"suppliers":[],"uoms":[{"material":{"cost":170,"price":340,"tax_id":null},"uom":"Items"}],"uom":"Items","item_type":"material","backup_name":"4’ walk gate steel","processed":true,"label":"4’ walk gate steel","value":"4’ walk gate steel","created_by":"l9yoe5zpk2niad2rxfipo1m","customer":"l9yoe5ze4vgz9kqd5lc2oa","date_created":1668137636,"date_updated":1696978437,"duplicate_from_id":"laby2u3czgwgvmwd8ah4onm","is_active":true,"location_id":1,"type":"product","photos":[]}],"sections":[],"jnid":null,"template_id":"l9yoe8e8fa9i6gjef1vgixi-22","is_archived":false,"original_total":0,"CAS":0,"is_fetched":false,"location_backup":{"id":0},"oldData":null,"action":"created","contact_id":"lagyj1grrxgpfq07lxu2eih","QuickBooksStatus":null,"isXactimate":false,"FooterHtml":null,"IsTemplate":false,"TemplateName":null,"locationid":1,"pages":null,"esign":null,"esigned":false,"no_access":false,"no_access_msg":null,"duplicate_from_id":null,"signers":[],"parentContact":{"Jnid":"lagyj1grrxgpfq07lxu2eih","Geo":{"lat":33.08288,"lon":-96.66946},"AddressLine1":"534 Northridge Dr","AddressLine2":"","City":"","State":"TX","CountryName":"United States","Email":"thejdela+21@gmail.com","HomePhone":"4696441715","MobilePhone":"4696441715","Name":"test test","WorkPhone":"4696441715","Zip":"75002"},"parentJob":null,"TaxList":[],"surchargeTotal":0,"postSurchargeTotal":340,"DateEstimate1":"1/24/2024","materialCost":170,"laborCost":0,"totalProfit":170,"profitMargin":"50.00"}',
    method: 'POST'
    // mode: 'cors',
    // credentials: 'include'
  })
    .then((response) => response.json())
    .catch((error) => console.log('error', error));
  return response;
}

async function getProducts(accessToken) {
  const headers = {
    accept: 'application/json, text/javascript, */*; q=0.01',
    'accept-language': 'en-US,en;q=0.9',
    authorization: 'Bearer ' + accessToken,
    'content-type': 'application/json',
    'sec-ch-ua': '"Not_A Brand";v="8", "Chromium";v="120", "Google Chrome";v="120"'
  };

  const response = await fetch('https://delicate-mud-81d7.nanosolutions.workers.dev/?https://app.jobnimbus.com/api2/product?_=1706121907324', {
    headers: { ...headers },
    referrer: 'https://webappui.jobnimbus.com/',
    referrerPolicy: 'strict-origin-when-cross-origin',
    body: null,
    method: 'GET'
    // mode: 'cors',
    // credentials: 'include'
  })
    .then((response) => response.json())
    .catch((error) => console.log('error', error));
  return response;
}

export { getContacts, createFile, login, getAccessToken, loginAndGetAccessToken, createEstimate, getProducts };
